/*
 * Do not change this file.
 */

const datastore = {
  namespaced: true,
  state: {
    entryLoaded: false,
    entriesLoaded: false,
    entry: "", // Active user datastore value
    entries: [] // Every user's datastore
  },
  mutations: {
    SET_ENTRY(state, entry) {
      state.entryLoaded = true;
      state.entry = entry;
    },
    SET_ENTRIES(state, entries) {
      state.entriesLoaded = true;
      state.entries = entries;
    }
  },
  actions: {
    setEntry({ commit }, entry) {
      commit("SET_ENTRY", entry);
    },
    setEntries({ commit }, entries) {
      commit("SET_ENTRIES", entries);
    }
  },
  getters: {
    getEntry(state) {
      let entry = "";
      try {
        entry = JSON.parse(state.entry);
      } catch (_e) {
        entry = state.entry;
      }

      return entry;
    },
    getEntries(state) {
      /*
       * Remove entries that have no value
       */
      let entries = state.entries.filter((entry) => entry.value !== "");

      /*
       * This assumes the datastore value is an object,
       * stored as a JSON string and needs to be parsed
       * before it can be used.
       */
      entries = entries.map((entry) => {
        let value = "";
        try {
          value = JSON.parse(entry.value);
        } catch (_e) {
          value = entry.value;
        }

        return value;
      });

      return entries;
    },
    getAdminEntries(state) {
      /*
       * Remove entries that have no value
       */
      let entries = state.entries.filter((entry) => entry.value !== "");

      /*
       * This assumes the datastore value is an object,
       * stored as a JSON string and needs to be parsed
       * before it can be used.
       */
      entries = entries.map((entry) => {
        /*
         * If the value has not been updated, then use the creation date
         */
        if (entry.tsUpdated == "") {
          entry.tsUpdated = entry.tsCreated;
        }

        let value = "";
        try {
          value = JSON.parse(entry.value);
        } catch (_e) {
          value = entry.value;
        }

        /*
         * Make a human-readable timestamp, localized to OSU
         */
        let date = new Date(entry.tsUpdated * 1000);
        let tsUpdatedLabel = date.toLocaleString("en-US", {
          timeZone: "America/Los_Angeles"
        });
        tsUpdatedLabel = tsUpdatedLabel.replace(",", "");

        /*
         * Create a new, smaller object for the admin report
         */
        return {
          value: value,
          fullname: entry.fullname,
          onid: entry.onid,
          tsUpdated: entry.tsUpdated,
          tsUpdatedLabel: tsUpdatedLabel
        };
      });

      return entries;
    }
  }
};

export default datastore;
